/**
 * ============================================================================
 * Factory 模块 - 枚举定义
 * ============================================================================
 * 
 * 📋 文件职责：
 * - 定义模块相关的所有枚举类型
 * - 包含：FactoryStatus 等
 * 
 * 📖 对应后端：
 * - Model: backend/app/Modules/System/Models/Factory.php (常量定义)
 * 
 * ⚠️ 注意事项：
 * - 枚举值必须与后端完全一致
 * - 每个枚举值必须添加中文注释
 * - 使用 TypeScript enum 而不是 type
 * 
 * 🔄 更新时机：
 * - 后端新增枚举值时
 * - 后端修改枚举值时
 * - 业务新增状态/类型时
 * 
 * ✅ 验证方式：
 * 让AI执行以下检查：
 * 1. 读取 backend/app/Modules/System/Models/Factory.php
 * 2. 找到所有 const STATUS_* 等常量定义
 * 3. 检查枚举值、名称是否与后端一致
 * 4. 检查是否有遗漏或多余的枚举值
 * 
 * @module types/factory/enums
 * @generated Manual (AI-assisted)
 * @last-updated 2025-10-18
 * ============================================================================
 */

/**
 * 工厂状态枚举
 * 
 * 对应后端：Factory::STATUS_*
 */
export enum FactoryStatus {
  /** 停用 */
  INACTIVE = 0,
  
  /** 运营中 */
  ACTIVE = 1,
}

